var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 134,
    viewBox: "0 0 133 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5137_20380)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65,
    r: 47.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.8555 90.222H38.1055V36.442C38.1112 35.7502 38.371 35.0847 38.8355 34.572C39.0991 34.261 39.4268 34.0107 39.7961 33.8381C40.1655 33.6655 40.5678 33.5747 40.9755 33.572H65.9755C66.3519 33.572 66.7246 33.6463 67.0723 33.7907C67.4199 33.935 67.7356 34.1466 68.0013 34.4132C68.267 34.6799 68.4775 34.9963 68.6206 35.3445C68.7638 35.6926 68.8368 36.0656 68.8355 36.442L68.8555 90.222Z",
    fill: "#00C65E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8555 90.2221H38.1055V36.4421C38.1055 34.8521 40.4755 61.2821 46.1855 69.3121C48.4823 72.4614 51.5553 74.9625 55.1055 76.5721C59.4556 78.4321 64.1446 79.3686 68.8755 79.3221L68.8555 90.2221Z",
    fill: "#08A636"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5352 40.4121V46.7921H63.7252V40.4121H59.5352Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6451 40.4121H43.4551V46.7921H47.6451V40.4121Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4941 40.4121V46.7921H55.6841V40.4121H51.4941Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5352 51.1421V57.5721H63.7252V51.1421H59.5352Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6451 51.1421H43.4551V57.5221H47.6451V51.1421Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4941 51.1421V57.5721H55.6841V51.1421H51.4941Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5332 61.8721V68.2521H63.7232V61.8721H59.5332Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4941 61.8721V68.2521H55.6841V61.8721H51.4941Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5352 74.6921V81.0721H63.7252V74.6921H59.5352Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3255 59.4421H86.1955C86.7869 59.4421 87.3541 59.6771 87.7723 60.0953C88.1905 60.5135 88.4255 61.0807 88.4255 61.6721V95.4821H59.1055V61.6721C59.1055 61.0824 59.339 60.5167 59.7551 60.0988C60.1711 59.6809 60.7358 59.4448 61.3255 59.4421Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2155 61.492H86.5755C87.1263 61.4947 87.6538 61.7147 88.0433 62.1042C88.4329 62.4937 88.6528 63.0212 88.6555 63.572V96.332H62.1055V63.572C62.1068 63.2967 62.1625 63.0244 62.2693 62.7707C62.3762 62.5169 62.5321 62.2868 62.7282 62.0935C62.9243 61.9003 63.1566 61.7476 63.4118 61.6444C63.6671 61.5412 63.9402 61.4894 64.2155 61.492Z",
    fill: "#FFB762"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3672 67.8721V72.3821H82.6372V67.8721H79.3672Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4263 67.8721H68.1562V72.3821H71.4263V67.8721Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7656 67.8721V72.3821H77.0256V67.8721H73.7656Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3672 75.4521V79.9621H82.6372V75.4521H79.3672Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4263 75.4521H68.1562V79.9621H71.4263V75.4521Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7656 75.4521V79.9621H77.0256V75.4521H73.7656Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3672 83.0322V87.5722H82.6372V83.0322H79.3672Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4263 83.0322H68.1562V87.5422H71.4263V83.0322Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7656 83.0322V87.5722H77.0256V83.0322H73.7656Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8955 43.302L92.8955 41.672L85.8955 40.022L84.1055 33.572L82.4355 40.022L75.4355 41.672L82.4355 43.302L84.1055 50.102L85.8955 43.302Z",
    fill: "#F89358"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9764 53.572L80.1064 52.572L75.9664 51.572L74.9664 47.772L73.9664 51.572L69.8164 52.572L73.9164 53.572L74.9164 57.572L75.9764 53.572Z",
    fill: "#00C65E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5137_20380",
    x: 0,
    y: 0.5,
    width: 133,
    height: 133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5137_20380"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.227451 0 0 0 0 0.270588 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5137_20380"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5137_20380",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.4abc1197d7f575395b5e3bc7510725c5.svg";
export { ForwardRef as ReactComponent };